import React from 'react';
import Title from '../../atoms/title/title.js';

const Table = ({ tableColumnsHeaders, data, tableTotalData }) => {
    return (React.createElement("div", { className: "mbw-table" },
        React.createElement("div", { className: "mbw-table-head" }, tableColumnsHeaders?.map((header) => {
            return (React.createElement("div", { key: header },
                React.createElement(Title, { fontStyle: "content-medium", bold: true }, header)));
        })),
        React.createElement("div", { className: "mbw-table-body" }, data?.map((item, index) => (React.createElement("div", { key: index, className: "mbw-table-row" },
            React.createElement("div", { className: "mbw-table-item" },
                React.createElement(Title, { fontStyle: "content-medium" }, item?.date)),
            React.createElement("div", { className: "mbw-table-item" },
                React.createElement(Title, { fontStyle: "content-medium" }, item?.invoiceId)),
            React.createElement("div", { className: "mbw-table-item" },
                React.createElement(Title, { fontStyle: "content-medium", bold: true },
                    item?.paymentData?.currency,
                    item?.paymentData?.amount + ".00"),
                React.createElement("div", { className: "mbw-table-item-source" },
                    React.createElement(Title, { fontStyle: "content-medium" }, item?.paymentData?.source))))))),
        React.createElement("div", { className: "mbw-table-total" },
            React.createElement(Title, { fontStyle: "content-medium" },
                tableTotalData?.total?.name,
                " : ",
                tableTotalData?.total?.amount),
            React.createElement("div", { className: "mbw-table-total-cash-back" },
                React.createElement(Title, { bold: true, fontStyle: "content-medium" },
                    tableTotalData.cashBack.percentage,
                    " ",
                    tableTotalData.cashBack.name,
                    " ",
                    tableTotalData.cashBack.amount)))));
};

export { Table as default };
//# sourceMappingURL=table.js.map
